export default function formatACS (ref) {
  const authors = ref.author.split('and').map(auth => auth.trim()).map(auth => {
    const names = auth.split(' ')
    const familyName = names.pop()
    const abbrNames = names.map(n => (n.endsWith('.') ? n : `${n[0]}.`)).join(' ')
    return `${familyName}, ${abbrNames}`
  })
  let html = `<span> ${authors.join('; ')} </span>`
  html += `<span>${ref.title}. </span>`
  if (ref.journal) html += `<span class="font-italic">${ref.journal} </span>`
  html += `<span class="font-weight-bold">${ref.year}, </span>`
  if (ref.volume) {
    html += `<span class="font-italic">${ref.volume}</span>` + (ref.number ? ' ' : ', ')
  }
  if (ref.number) {
    html += `<span>(${ref.volume}), </span>`
  }
  if (ref.pages) {
    html += ref.pages
    if (ref.from) html += ', '
  }
  if (ref.from) html += `available from: <a href="${ref.from}" target="_blank">${ref.from.replace('http://', '')}`
  html += '.'
  if (ref.doi) {
    html += `<span> ${ref.doi}.</span>`
  }
  return html
}
